import { render, staticRenderFns } from "./ListLabourerPage.vue?vue&type=template&id=04907966&scoped=true&"
import script from "./ListLabourerPage.vue?vue&type=script&lang=js&"
export * from "./ListLabourerPage.vue?vue&type=script&lang=js&"
import style0 from "./ListLabourerPage.vue?vue&type=style&index=0&id=04907966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04907966",
  null
  
)

export default component.exports